<template>
<div>
  <va-modal
    :value="isOpen"
    id="resyncPatientExternallyModal"
    ref="resyncPatientExternallyModal"
    size="large"
    :showOkay="true"
    :ok-text="$t('buttons.sync')"
    :cancelText="$t('modal.close')"
    @ok="handleSync"
    @cancel="onClickCancel">
    <div class="person-details evollu-form">

      <div class="row">
        <h4>
          {{ $t(`people_manager.patient.resync_patient_title`)}}
        </h4>
      </div>
      <div>
        <span>
          {{$t('people_manager.patient.resync_patient_body', {patientName: handlePatientName()})}}
        </span>
      </div>
    </div>
  </va-modal>
</div>
</template>

<script>
import { PeopleManagerService } from '@/api/PeopleManagerService';

export default {
  props: {
    person: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      isOpen: false,
      loading: false
    }
  },
  mounted() {
    this.isOpen = true
  },
  methods: {
    onClickCancel: function () {
      this.$emit('close')
      setTimeout(() => {
        this.isOpen = false
      }, 500)
    },
    handlePatientName: function () {
      var str = ''
      if(this.person && this.person.firstName) {
        str += this.person.firstName
        if (this.person.lastName) {
          str += ' '+this.person.lastName
        }
      }
      return str
    },
    handleSync: async function() {
      try {
        const resp = await PeopleManagerService.resyncPerson(this.person.id)
        this.$emit('close', resp)
        setTimeout(() => {
          this.isOpen = false
        }, 500)
      } catch (err) {
        console.log(err)
        this.onClickCancel()
      }
    }
  }
};
</script>

<style scoped lang="scss">

</style>
